"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BirthDeath = function BirthDeath(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ className: "custom-icon", viewBox: "0 -8 24 24" }, props),
    _react2.default.createElement("path", {
      d: "M20,4 L20,6 L7,6 L7,0 L16,0 C18.21,0 20,1.79 20,4 Z M0,7 L0,9 L6,9 L6,11 L14,11 L14,9 L20,9 L20,7 L0,7 Z M5.14,5.1 C6.3,3.91 6.28,2.02 5.1,0.86 C3.91,-0.3 2.02,-0.28 0.86,0.9 C-0.3,2.09 -0.28,3.98 0.9,5.14 C2.09,6.3 3.98,6.28 5.14,5.1 Z",
      id: "path-1"
    })
  );
};

exports.default = BirthDeath;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/birth-death.js
// module id = ../lib/egov-ui-kit/custom-icons/birth-death.js
// module chunks = 504